module.exports = __webpack_public_path__ + "fonts/Avenir-Oblique.6c95a10.woff2";